import type {ModelFamily} from './ModelFamily';

export type Make = {
  models: Record<string, ModelFamily>;
  isCustom: boolean;
};
